<!-- eslint-disable  -->
<template>
  <div class="w-100">
    <div class="row select-another-carrier mx-4 p-4">
      <div class="col-12">        
        <span class="carrier-logo" v-if="carrierData.logoPathSvg">
          <img :src="carrierData.logoPathSvg" :alt="carrierData.carrier_name"/>
        </span>
      </div>
      <div class="col-12 msg-col">
        <p v-if="!errorMessage"><strong>Reminder:</strong> If you did not already, please continue to the <strong>{{ carrierData.carrier_name }}&#39;s</strong> agent platform in a new browser tab to complete the bind of this {{ carrierType }} policy.</p>
        <p v-else class="m-0" v-html="errorMessage.msg"></p>
      </div>
      <div class="col-12" v-if="!errorMessage">
        <button type="submit" class="btn btn-primary continue-to-carrier" @click.prevent="continueToCarrier">
          CONTINUE TO {{ carrierData.carrier_name }}
          <i class="fa fa-open-in-new ml-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z" fill="currentColor"/>
            </svg>
          </i>
        </button>                    
      </div>                  
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props:['carrierType', 'errorMessage'],
  data() {
  },
  computed: {    
    carrierData() {
      if (this.carrierType === 'Auto') {
        return sessionStorage.getItem('selectedCarrierAuto') != null ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')) : false;
      }       
      return sessionStorage.getItem('selectedCarrierHome') != null ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')) : false;
    },
  },
  methods: {
    continueToCarrier() {     
      let externalUrl = '';
      if (this.carrierType === 'Auto') {
        externalUrl = sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).external_url : '';        
        if (externalUrl == '' || externalUrl == null && sessionStorage.getItem('pdfLinkCov') != null) {
          let pdfLinkCov = JSON.parse(sessionStorage.getItem('pdfLinkCov'));
          externalUrl = pdfLinkCov && pdfLinkCov.length === 1 ? pdfLinkCov[0].field_value : pdfLinkCov && pdfLinkCov.length > 1 ? pdfLinkCov[1].field_value : '';
        }
      } else {
        externalUrl = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).external_url : '';
        if (externalUrl == '' || externalUrl == null && sessionStorage.getItem('homePdfLinkCov') != null) {
          let homePdfLinkCov = JSON.parse(sessionStorage.getItem('homePdfLinkCov'));
          externalUrl = homePdfLinkCov && homePdfLinkCov.length === 1 ? homePdfLinkCov[0].field_value : homePdfLinkCov && homePdfLinkCov.length > 1 ? homePdfLinkCov[1].field_value : '';
        }
      }
      if (externalUrl) {
        window.open('#','_blank');window.open(externalUrl,'_self');
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .select-another-carrier {
    border-radius: 8px;
    border: 1px solid #CCC;
    text-align: center;

    p {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      text-align: left;
    }
    .continue-to-carrier {
      color: #00234F;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      text-transform: uppercase;
      border-radius: 4px;
      border: 1px solid #00234F;
      background-color: #FFFFFF;

      &:hover {
        background-color: #00234F;
        color: #FFFFFF;
        svg {
          color: #FFFFFF;
        }
      }
      .fa-open-in-new {
        top: -1px;
        position: relative;
      }
    }
    .carrier-logo {
      img{
        width: 113px;
      }
    }
    .msg-col {
      margin-top: 12px;
      margin-bottom: 24px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/interview/shared/BundleConfirmationReminder.vue?e2b0bb66